export const MOTION = {
  duration: { fast: 0.25, standard: 0.5, reveal: 0.75, hero: 1.0 },
  ease: { premium: [0.22, 1, 0.36, 1], soft: [0.4, 0, 0.2, 1], spring: { type: "spring", stiffness: 260, damping: 26, mass: 0.8 } },
  stagger: { cards: 0.09, words: 0.05, lines: 0.12 },
  viewport: { once: true, amount: 0.05, margin: "0px 0px -6% 0px" },
  cursor: { dot: 10, ring: 36, dotLerp: 0.35, ringLerp: 0.16, trailLerp: [0.12, 0.09, 0.065], trailCount: 3 },
  magnetic: { max: 8, strength: 0.28 },
  parallax: { max: 18 },
};

export const REVEAL_VARIANTS = {
  fade: { hidden: { opacity: 0 }, show: { opacity: 1 } },
  up: { hidden: { opacity: 0, y: 32 }, show: { opacity: 1, y: 0 } },
  blur: { hidden: { opacity: 0, y: 28, filter: "blur(8px)" }, show: { opacity: 1, y: 0, filter: "blur(0px)" } },
  scale: { hidden: { opacity: 0, scale: 0.94 }, show: { opacity: 1, scale: 1 } },
  left: { hidden: { opacity: 0, x: -40 }, show: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: 40 }, show: { opacity: 1, x: 0 } },
  clip: { hidden: { clipPath: "inset(0 0 100% 0)", y: 12 }, show: { clipPath: "inset(0 0 0% 0)", y: 0 } },
};

export const isFinePointer = () => typeof window !== "undefined" && window.matchMedia("(any-pointer: fine) and (any-hover: hover)").matches;
